const state = {
  oidBatInfo: null,
}

const getters = {
}

const mutations = {
  setOidBatInfo (state, v) {
    state.oidBatInfo = v
  }
}

const actions = {
  updateOidbat ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder-bat/update-oidbat', params)
  },
  payPrepare ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/jyorder-bat/pay-prepare', { params })
  },
  payByOidbat ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder-bat/pay-by-oidbat', params)
  },
  refundByOidbat ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder-bat/refund-by-oidbat', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
